import { cn } from '@nexo/ui';
import { useTranslation } from 'react-i18next';
import { isDesktop } from '../lib/platform';

/** Version of Nexo this screen belongs to (web build or desktop app), shown everywhere. */
export function AppVersion({ className }: { className?: string }) {
  const { t } = useTranslation();
  const where = isDesktop ? t('App de escritorio') : t('Web');
  return (
    <span
      className={cn('tabular-nums', className)}
      title={t('{{where}} · versión {{version}}', { where, version: __APP_VERSION__ })}
    >
      v{__APP_VERSION__}
    </span>
  );
}
